import {
  FilterCategories,
  filterCategories,
  FilterOptions,
  Filters
} from '@server/careers-backend/search';

export const orderFilters = (
  filters: Filters | undefined
): Array<{ key: string; options: FilterOptions }> => {
  const order = [
    filterCategories.workingAreas,
    filterCategories.functions,
    filterCategories.cities,
    filterCategories.educationLevels,
    filterCategories.jobTypes,
    filterCategories.hours,
    filterCategories.isCoolblueEnergy,
    filterCategories.visibility
  ];

  return Object.entries(filters || {})
    .map(([key, filterItems]) => ({
      key: key as FilterCategories,
      options: filterItems
    }))
    .sort((a, b) => {
      const indexA = order.indexOf(a.key);
      const indexB = order.indexOf(b.key);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });
};
